<template>
  <div id="Newproductbox" style="width:100%">
    <!-- <div class="container-fluid"> -->
      <!-- <div class="TabHeader">
        <div class="Title">{{ this.ThenCatalogId > 0 ? GetCatalogName : $t('lbl_EMPBE_ProductInfo_Catalog_NewCatalog') }}
        </div>
      </div> -->
<!-- 
      <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:100vh;overflow:hidden;' : ''">  -->
       

        <div class="tbbody">
        
        <b-form :class="fromAdmin?`formAdmin`:`form`" class="theme-form datepicker-responsive" id="productInfoForm"> 
          <!--管理员界面头部-->
        <div class="TabHeader_admin customStickyCardHeader"  v-if="fromAdmin"  >
          <div class="TabHeader_body" style=""> 
           <div style="gap: 4px; display: flex"> 
            <div class="lblCatalogList"  @click="backToDefaultPage">{{ $t('lbl_EMPBE_ProductIndex')}} 
              <!-- <span class="split" ></span> -->
            </div>
            <i class="fa fa-angle-right iconRight" aria-hidden="true" ></i>
            <div  class="productTitle">{{ this.ThenCatalogId > 0 ? GetCatalogName() : $t('lbl_EMPBE_ProductInfo_Catalog_NewCatalog') }}</div>
        </div> 


         <div  class="topMenuRight">
            <div style="color: rgba(0, 0, 0, 0.80); font-size: 16px; font-weight: 700; line-height: 20.80px; word-wrap: break-word">{{ $t('lbl_buyerform_status') }}</div>
         <div>
          
        
              <!-- <div v-if="GetPageState == 0" class="DraftColor">
                {{ $t('lbl_EMPBE_Draft') }}
              </div>
              <div v-else-if="GetPageState == 1" class="ActivateColor">
                {{ $t('lbl_EMPBE_isActivate') }}
              </div>
              <div v-else class="DelistedColor">
                {{ $t('lbl_EMPBE_isDelisted') }}
              </div>  -->
              <PubCustomSelect  :LiList="GetLiList" @ResultClick="DeleteAndDelisted">
                <template v-slot:HeadTitle>
                  <div v-if="GetPageState == 0" class="DraftColor">
                    {{ $t('lbl_EMPBE_Draft') }}
                  </div>
                  <div v-else-if="GetPageState == 1" class="ActivateColor">
                    {{ $t('lbl_EMPBE_isActivate') }}
                  </div>
                  <div v-else class="DelistedColor">
                    {{ $t('lbl_EMPBE_isDelisted') }}
                  </div>
                </template>
              </PubCustomSelect>

        </div>
          </div>        
        </div>
        </div>
        <div v-else class="TabHeader " >
        <div class="TabHeader_body" style=""> 
        <div style="gap: 4px; display: flex">
           <!--  <div style="" class="backToDefaultPage"> 
                <div style="width: 25.60px; height: 25.60px; position: relative; overflow: hidden">
                  <img src="https://cdn.adsalecdn.com/EMP/Backend/svg/ProductInfo/arrowLeft.svg">
                </div> 
            </div>-->
            <div class="lblCatalogList"  @click="backToDefaultPage">{{ $t('lbl_EMPBE_ProductIndex')}} 
              <!-- <span class="split" ></span> -->
            </div>
            <i class="fa fa-angle-right iconRight" aria-hidden="true" ></i>
            <div  class="productTitle" >{{ this.ThenCatalogId > 0 ? GetCatalogName() : $t('lbl_EMPBE_ProductInfo_Catalog_NewCatalog') }}</div>
        </div> 


         <div  class="topMenuRight">
            <div style="color: rgba(0, 0, 0, 0.80); font-size: 16px; font-weight: 700; line-height: 20.80px; word-wrap: break-word">{{ $t('lbl_buyerform_status') }}</div>
         <div>
          
          <PubCustomSelect  :LiList="GetLiList" @ResultClick="DeleteAndDelisted">
            <template v-slot:HeadTitle>
              <div v-if="GetPageState == 0" class="DraftColor">
                {{ $t('lbl_EMPBE_Draft') }}
              </div>
              <div v-else-if="GetPageState == 1" class="ActivateColor">
                {{ $t('lbl_EMPBE_isActivate') }}
              </div>
              <div v-else class="DelistedColor">
                {{ $t('lbl_EMPBE_isDelisted') }}
              </div>
            </template>
          </PubCustomSelect>
        </div>
          </div>        
        </div>
        </div>
         
          <PageValidate ref="indexDetail">
            <template v-slot:PageBody>
              <b-card no-body class="bCard">
          
               <b-card-body>
     
              <div class="productionLineBody">
                <div v-if="AplusABCBooth">
                  <div class="row titlerow">
                    <div class="col-10 productionLineBodyTitle">
                      {{ $t('lbl_EMPBE_ProductInfo_Catalog_ProductRelated') }}
                    </div>
                    <div class="col-2">
                      <span style="color: red">*</span> {{ $t('lbl_EMPBE_CompanyInfo_Basic_Required') }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-10">
                      <multiselection v-model="form.ProductIds" label="name" track-by="code" :options="ProductList"
                        :multiple="true" :taggable="true"
                        :title="$t('lbl_EMPBE_ProductInfo_Catalog_ProductRelated_PlaceOther')">
                      </multiselection>
                    </div>
                  </div>
                </div>
                <div style="margin-bottom: 1rem;">
                  <div class="row">
                    <div class="col-12 productionLineBodyTitle titlerow">
                      {{ $t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog') }}
                    </div>
                    <div class="col-12 titlerow">
                      <ul>
                        <li>
                          {{ $t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_P') }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 ">
                      <mediaUploader 
                          :MediaArray="uploadedCover"
                          :limit="1" 
                          aspectRatioStr="1:1.42" 
                          galleryItemStyle="height: 120px; width: 85px;" 
                          mediaType="image"
                          ref="ExhibitCatalog_Cover"
                          fileUsageType="ExhibitCatalog_Cover"
                          filePathEndpoint="Image"
                          @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'ExhibitCatalog_Cover')"
                      />
                    </div>
                  </div>
                </div>
                <div style="margin-bottom: 1rem;">
                  <div class="row">
                    <div class="col-12 productionLineBodyTabTitle">
                      {{ $t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_FooterP') }}
                    </div>
                  </div>
                </div>
                <div> 
                    <PublicTabs v-model="TabIndex" :TabList="TabList" :TabStyle="0" :Loading="false"
                      style="width: 100%;" :IsSavePrompt="false">
                      <template v-slot:tab0>
                        <indexDetailUpload :id="'PdfDataEn'" :key="'PdfDataEn'" ref="PdfDataEn" v-model="GetPdfObjEn">
                        </indexDetailUpload>
                      </template>
                      <template v-slot:tab1>
                        <indexDetailUpload :id="'PdfDataSc'" :key="'PdfDataSc'" ref="PdfDataSc" v-model="GetPdfObjSc">
                        </indexDetailUpload>
                      </template>
                      <template v-slot:tab2>
                        <indexDetailUpload :id="'PdfDataTc'" :key="'PdfDataTc'" ref="PdfDataTc" v-model="GetPdfObjTc">
                        </indexDetailUpload>
                      </template>
                    </PublicTabs> 
                </div>
                <!-- <div class="row">
                <div class="col-12 title">
                  <div class="btnCopyToOtherLang" @click="copyToOtherLang">
                  {{ $t('lbl_EMPBE_ApplySameFileInDiffLang') }}
                  </div>
                </div>
                    
                 </div> -->
              </div>
               </b-card-body>
          </b-card>
            </template>
          </PageValidate>
          <div class="customizer-formbutton" v-if="$route.params.id&&!fromAdmin">
            <b-button-group>
              <!-- <button type="button"  class="btn btn-danger btn-lg" @click="deleteCatalog()" v-if="this.ThenCatalogId > 0" v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_' + ThenCatalogId + '_btnDelete'">
                <i class="fa fa-trash-o m-r-5"></i>{{ $t("lbl_EMPBE_Delete") }}
              </button> -->
               <button :disabled="SaveBtnClick" type="button" class="btn btn-primary btn-lg" @click="btnSave_Click"
                v-if="GetPageState != 1" v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSave'">
               <i class="fa far fa-save m-r-5"></i> 
                {{ $t("lbl_EMPBE_CompanyInfo_SaveDraft") }} 
              </button>

              <button type="button" class="btn btn-success btn-lg" @click="btnSubmit_Click"
                v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_btnSubmit'">
                <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_CompanyInfo_Submit") }}
              </button>
            </b-button-group>
          </div>
           <div class="customizer-formbutton" v-if="fromAdmin">
             <button :disabled="SaveBtnClick" type="button" class="btn btn-outline-info btn-lg" @click="btnSave_Click"
                v-if="GetPageState != 1" v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSave'"> 
                {{ $t("lbl_EMPBE_Save2") }} 
              </button>

              <button v-else type="button" class="btn btn-outline-info btn-lg" @click="btnSubmit_Click"
                v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_btnSubmit'">
                {{ $t("lbl_EMPBE_CompanyInfo_Submit") }}
              </button>
           </div>
         
        </b-form>
        </div>
          
     
 
       
      <!-- </b-overlay> -->

    <!-- </div> -->
  </div>
</template>
<script>
import { productService } from "@/_services/product.service";
import indexDetailUpload from "./Popup/indexDetailUpload.vue"
import { LogService } from "../../_services/log.Service";
import mediaUploader from "../../components/form/upload/imgUploader/mediaUploader.vue";
import { AlertDialog } from "@/_helpers/AlertDialog";
import { getInitImageDataObj, toPendingUploadQueueData } from '@/_helpers/media-uploader-utils.js';
import { mapState } from "vuex";

const defaultUploadResult = {
  isSuccessful: true,
  message: "",
  failedItems: [],
};

export default {
  components: { indexDetailUpload, mediaUploader },
  props: ["supplierId", "catalogId","fromAdmin"],
  inject: ["permissionData", "ChildSubmit"],
  mixins: [AlertDialog],
  data() {
    return {
      ProductList: [],
      TabIndex: 0,
      loading: false,
      TabList: [
        { name: this.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_Engilsh'), status: 0, t_label: "EMPBE_ProductInfo_Index_Simplified", IsShow: true, lang: 1252 },
        { name: this.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_SimplifiedChinese'), status: 0, t_label: "EMPBE_ProductInfo_Index_Traditional", IsShow: true, lang: 936 },
        { name: this.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_TraditionalChinese'), status: 0, t_label: "EMPBE_ProductInfo_Index_English", IsShow: true, lang: 950 },
      ],
      form: {
        CatalogueModel: {          
        },
        ProductIds: [],
        coverPhoto: null,
        pdfList: [
          {
            id: null,
            catalogName: "",
            fileName: "",
            fileData: null,
            type: "catalogPdfEn",
            langId: 1252,
            usageType: "ExhibitCatalog_Pdf_EN"
          },
          {

            id: null,
            catalogName: "",
            fileName: "",
            fileData: null,
            type: "catalogPdfSc",
            langId: 936,
            usageType: "ExhibitCatalog_Pdf_SC"
          }
          , {
            id: null,
            catalogName: "",
            fileName: "",
            fileData: null,
            type: "catalogPdfTc",
            langId: 950,
            usageType: "ExhibitCatalog_Pdf_TC"
          }
        ]
      },
      uploadedCover: [],
      dbUpdateCommands: {
        ExhibitCatalog_Cover: []
      },
      pendingUploadFiles: {
        ExhibitCatalog_Cover: []
      },
      LiList: [
        { name: this.$t('lbl_EMPBE_ProductInfo_Delist'), eventName: "Delist", status: 0 },
        { name: this.$t('lbl_EMPBE_Delete'), eventName: "Delete", status: 1 },
      ],
      SaveBtnClick: false,
      PageLeaveContent: {
        SubmitTitle: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title'),
        SubmitText: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body'),
        SubmitConfirmBtn: this.$t('lbl_EMPBE_CompanyInfo_Submit'),
        SaveTitle: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title'),
        SaveText: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body'),
        SaveConfirmBtn: this.$t('lbl_EMPBE_CompanyInfo_Save'),
      },
      uploadResult: { ...defaultUploadResult },
    };
  },
  computed: {
    ...mapState("submitFormMessage", { isShowSubmitAlertMessage : "isShowModal" }),

    AplusABCBooth() {
      if (this.permissionData) {
        return ["A+","A", "B", "C"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId === null ||
        this.supplierId === undefined ||
        this.supplierId === ""
        ? this.user.empCompanyId
        : this.supplierId;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    ThenCatalogId() {
      return (this.$route.params.id || this.catalogId) || 0;
    },
    GetPdfObjSc: {
      get() {
        return this.form.pdfList.find(item => item.langId == 936);
      },
      set(newValue) {
        return newValue;
      },
    },
    GetPdfObjTc: {
      get() {
        return this.form.pdfList.find(item => item.langId == 950);
      },
      set(newValue) {
        return newValue;
      },
    },
    GetPdfObjEn: {
      get() {
        return this.form.pdfList.find(item => item.langId == 1252);
      },
      set(newValue) {
        return newValue;
      }
    },
    GetLiList() {
       const status=this.GetPageState;
      if(this.fromAdmin)//管理员界面权限
      {
          if (status == 0 || status == 2)
          return []
        else if(status==1)
          return this.LiList.filter(item => item.eventName === 'Delist');
      }else{
      if (status == 0 || status == 2)
          {
          return this.LiList.filter(item => item.eventName === 'Delete') 
        }else{ 
          return this.LiList;
        } 
      }
    },
      GetPageState() {
       if(this.form.CatalogueModel){
          if (this.form.CatalogueModel.lastSubmitDate&&(this.form.CatalogueModel.isLaunch == 1|| this.form.CatalogueModel.isLaunch == true)) {
            //上架
           return 1
          }
          //下架之后再次保存，状态变为草稿（新加）
          else if (!this.form.CatalogueModel.lastSubmitDate||(this.form.CatalogueModel.lastSaveDate&&this.form.CatalogueModel.lastSubmitDate&&this.form.CatalogueModel.lastSaveDate>this.form.CatalogueModel.lastSubmitDate)) 
          {
            //草稿
            return 0;
           }  else {
          //下架
          return 2
         }
       }else if(this.ThenCatalogId==0) 
       {
         return 0;
       }
       else{
         return 0;
       }
    },
    GetPageStateName() {
      if (this.GetPageState == 0) {
        return '草稿'
      }
      else if (this.GetPageState == 1) {
        return '上架'
       }else{
        return '下架'
       }
       
    }
  },
  watch:
  {
    form: {
      handler() {
        if (!this.IsCreated) {
          this.$store.state.dirty = true;
        }
      },
      deep: true,
    },

    isShowSubmitAlertMessage: {
      handler(newValue, oldValue) {
        if (newValue === false && oldValue === true) {
          this.AfterHideMessageModal();
        }
      }
    },

    //在default.vue 页面 层级中需要做离开此页是否保存的操�?所以这里只能用监听以及跨层级来触发他的提交
    // ChildSubmit: {
    //   handler() {
    //     if (this.ChildSubmit.CatalogueState) {
    //       this.Submit();
    //     }
    //   },
    //   deep: true
    // },
  },
  mounted() {
    this.InitData(); 
  },
  methods: {
    AfterHideMessageModal() {
      this.uploadResult = { ...defaultUploadResult };
    },

    resetFilePendingUpdate() {
      for (const prop in this.dbUpdateCommands) {
        this.$set(this.dbUpdateCommands, prop, []);
      }

      for (const prop in this.pendingUploadFiles) {
        this.$set(this.pendingUploadFiles, prop, []);
      }
    },

    // [BLK] Only update the stored data arrays for later manipulation
    handlerUploaderUpdateData(commands, pendingFiles, uploaderType) {
      this.dbUpdateCommands[uploaderType] = [...commands];
      this.pendingUploadFiles[uploaderType] = [...pendingFiles];
    },

    InitData(catalogid = 0) {
      this.loadData(catalogid);
      this.GetOptions();
    },
    GetCatalogName() {
      if(this.form.CatalogueModel)
      return this.form.CatalogueModel.name;
      else 
      return this.$t('lbl_EMPBE_ProductInfo_Catalog_NewCatalog');
    },
    //获取初始化数?
    loadData(catalogid) {
      this.loading = true;
      this.IsCreated = true;
      this.resetFilePendingUpdate();

      if (!catalogid) {
        catalogid = this.ThenCatalogId;
      }

      productService.GetProductCatalogueById({ companyId: this.companyid, catalogId: catalogid,langId:this.langid }).then(res => {
        if (res.isSuccessful) {
          this.form.ProductIds = res.data.projectIds;
          this.form.CatalogueModel = res.data.catalogueModel; 
          //cover
          this.uploadedCover = [];
          const coverData = res.data.coverPhoto;
          if (coverData && coverData.fileName) {
            this.form.coverPhoto = { ...coverData };
            const id = coverData.rid;
            const cdnLink = coverData.fileName;
            this.uploadedCover.push(getInitImageDataObj(coverData, { id, cdnLink, orderId: 1, usageType: 'ExhibitCatalog_Cover' }));
          }
          //pdf
          res.data.pdfList.forEach(item => {
            var obj = this.form.pdfList.find(x => x.langId == item.langId)
            obj.catalogName = item.name;
            obj.fileName = item.fileName;
            obj.id = item.rid;
            obj.fileData = null;
          });
        }

        this.$nextTick(() => {
          this.resetFormVerify();
        });

        setTimeout(() => {
          this.IsCreated = false;
        }, 500);
        this.loading = false;
      });
       setTimeout(() => {
        this.dirty = false;
        this.$store.state.dirty = this.dirty;
      }, 200);
    },
    GetOptions() {
      //获取产品列表
      productService.GetProductList({ companyid: this.companyid }).then(res => {
        if (res.isSuccessful) {
          this.ProductList = res.data.map(item => {
            return {
              id: item.productId,
              label: this.ConvertData(item)
            }
          })
        }
      })

    },
    ConvertData(item) {
      var nameS = !item.nameS ? (!item.nameT ? (!item.nameE ? this.$t('Lbl_Products') : item.nameE) : item.nameT) : item.nameS
      var nameT = !item.nameT ? (!item.nameS ? (!item.nameE ? this.$t('Lbl_Products') : item.nameE) : item.nameS) : item.nameT
      var nameE = !item.nameE ? (!item.nameT ? (!item.nameS ? this.$t('Lbl_Products') : item.nameS) : item.nameT) : item.nameE
      return (this.langid == 936 ? nameS : (this.langid == 950 ? nameT : nameE))
    },
    CheckTabRequied() {
      this.form.pdfList.forEach(item => {
        var tab = this.TabList.find(a => a.lang == item.langId);
        if (!(item.fileName || item.fileData) || !item.catalogName) {
          tab.status = 1;
        } else {
          tab.status = 0;
        }
      })
    },
    //刷新父级
    refreshParent() {
      // this.$parent.$emit('fetchData');
      //this.$parent.$parent.$parent.$parent.refresh();
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.indexDetail.reset();
      this.TabList.forEach(item => {
        item.status = 0;
      });
    },

    LogPageFormError(dataObj, action) {
      LogService.LogFormErrorWithObj(
        {
          EmpCompanyId: this.companyid,
          EmpProductId: 0,
          PageName: this.$route.path.split("/")[1],
          SectionName: "ProductCatalog_Index",
          Action: action,
        },
        {
          ...dataObj,
          catalogId: this.ThenCatalogId,
        }
      );
    },

    uploadFinish(failedFilesFields) {
      const isSuccess = failedFilesFields.length === 0;

      this.uploadResult.isSuccessful = isSuccess;
      this.uploadResult.failedItems = [...this.uploadResult.failedItems, ...failedFilesFields];

      this.$submitFormMessage.FinishUploadPopup({ isSuccess });
    },

    showResultMessagePopup(isSuccess, message, isSubmit) {
      this.$store.state.dirty = false;

      const isSuccessful = isSuccess && this.uploadResult.isSuccessful;
      const uploadFailedItems = this.uploadResult.failedItems;
      let header = '';

      if (isSuccess && isSubmit && !message) {
        message = this.$t("lbl_EMPBE_Company_SubmitSuccess_Body");
        header = this.$t("lbl_EMPBE_Company_SubmitSuccess_Title");
      } else if (isSuccess && !isSubmit && !message) {
        message = this.$t("lbl_EMPBE_Save_Success");
      }

      this.$submitFormMessage.ShowResultPopup({
        isSuccess: isSuccessful,
        message,
        isSubmit,
        uploadFailedItems,
        header,
      });
    },

    fileUploadHandle(isSubmit = true) {
      const pendingFiles = [...this.pendingUploadFiles.ExhibitCatalog_Cover];

      const pendingUploadPdfs = this.form.pdfList.filter((item) => item.fileData && item.fileData.length > 0);
      if (pendingUploadPdfs.length > 0) {
        for (let i = 0; i < pendingUploadPdfs.length; i++) {
          const element = pendingUploadPdfs[i];
          const id = `${this.ThenCatalogId}_` + element.usageType;
          const file = element.fileData[0];
          const fileName = file.name ?? element.fileName;
          const splitedFileName = fileName.split(".");
          const fileExtension = splitedFileName.length > 1 ? splitedFileName[splitedFileName.length - 1] : "pdf";

          pendingFiles.push(toPendingUploadQueueData({
            id,
            file,
            fileName,
            fileExtension,
            usageType: element.usageType,
            pathEndpoint: "Pdf",
          }));
        }
      }

      const that = this;

      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands: [],
        getFailedText: {
          "ExhibitCatalog_Cover": this.$t("lbl_EMPBE_ProductInfo_Catalog_CoverCatalog"),
          "ExhibitCatalog_Pdf_EN": that.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogFile', { Language: that.$t("lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_Engilsh") }),
          "ExhibitCatalog_Pdf_TC": that.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogFile', { Language: that.$t("lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_TraditionalChinese") }),
          "ExhibitCatalog_Pdf_SC": that.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogFile', { Language: that.$t("lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_SimplifiedChinese") }),
        },
        uploadFinishCallback: this.uploadFinish
      });
    },
    //整理結果提交save
    async AfterSaveResult(isSubmit = true) {
      var data = {
        EmpCompanyId: this.companyid,
        CatalogId: this.ThenCatalogId ?? 0,
        ProductIds: this.form.ProductIds.join(','),
        CoverFileName: "",
        CataloguePdfs: [],
        VaildError: [], //验证失败的filed
        validationErrorLog: "" //验证的errorlog
      };

      try {
        const res = await this.fileUploadHandle(isSubmit);
        const uploadedCover = res.successfulList.find((x) => x.usageType === 'ExhibitCatalog_Cover');
        if (uploadedCover) {
          data.CoverFileName = uploadedCover.uploadedOssUrl;
        } else if (this.uploadedCover.length === 1 && !this.dbUpdateCommands.ExhibitCatalog_Cover.find((c) => c.command === 'DELETE')) {
          data.CoverFileName = this.uploadedCover[0].cdnLink;
        }

        const uploadedPdfs = res.successfulList.filter((x) => x.usageType?.toLowerCase().startsWith('ExhibitCatalog_Pdf'.toLowerCase()));
        data.CataloguePdfs = this.form.pdfList.map((x) => {
          if (!uploadedPdfs.length) {
            return {
              langId: x.langId,
              catalogName: x.catalogName,
              fileName: x.fileName
            };
          }

          const pdf = uploadedPdfs.find((y) => y.usageType === x.usageType);
          return {
            langId: x.langId,
            catalogName: x.catalogName,
            fileName: pdf ? pdf.uploadedOssUrl : x.fileName,
          };
        });
      } catch (error) {
        this.LogPageFormError(
          {
            Error: {
              ErrorName: error.name,
              ErrorMessage: error.message,
              ErrorStack: error.stack
            }
          },
          "AfterSaveResult"
        );
        console.error(error);
        data.validationErrorLog += error
      }

      return data;
    },
    async btnSave_Click() { 
      var data = await this.AfterSaveResult(false);

      const query = {
        FormId: this.companyid,
        Action: 'Before_Save',
        FormType: 'ProductInfo_Catalogue',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      productService.SaveCatalogue(data).then(async res => {
        if (res.isSuccessful) {
          if (!this.fromAdmin && this.ThenCatalogId == 0) {
            this.$router.replace('/productInfoCenter/indexDetail/' + res.data);
          }

          const that = this;
          that.$nextTick(() => {
            that.InitData(parseInt(res.data ?? 0));
            that.$submitFormMessage.NextStepSubmitMessagePopup({ isCurrentStepFailed: false });
            that.$store.state.dirty = false;

            // if(that.fromAdmin) {
            that.$submitFormMessage.HideMessagePopup();
            that.showSaveSucess(that.$t('lbl_EMPBE_Save_Success'), that.$t('lbl_EMPBE_ProductInfo_Submit_Body')).then(async isconfirm => {
              if (isconfirm.isConfirmed) {
                const ressubmit = await that.Submit();

                if (ressubmit && ressubmit.state) {
                  that.$nextTick(() => {
                    that.showResultMessagePopup(true, "", true);
                    if (that.fromAdmin) {
                      that.InitData(parseInt(ressubmit.data ?? 0));
                      that.$store.state.dirty = false;
                    } else {
                      that.$router.replace({ path: '/productInfoCenter/default', query: { tab: 'Catalog' } });
                    }
                  });
                }
              }
            });
          });
        } else {
          this.LogPageFormError({ res: res }, "SaveCatalogue");
          this.showResultMessagePopup(false, this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg.join(",") }), false);
        }
      }).catch(err => {
        this.LogPageFormError({ Error: { ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack } }, "SaveCatalogue");
        this.showResultMessagePopup(false, this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message }), false);
      });
    },
    async btnSubmit_Click() {
      // console.log('index-Detail - btnSubmit_Click')
      // this.$swal({
      //   //Show Alert
      //   text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
      //   showCancelButton: true,
      //   type: "confirm",
      //   showConfirmButton: true,
      //   confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
      //   cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      // }).then(async (res) => {
      //   if (res.isConfirmed) {
      const res = await this.Submit();
      if (res && res.state) {
        this.$nextTick(() => {
          this.showResultMessagePopup(true, "", true);
          this.InitData(parseInt(res.data ?? 0));
        });
          // if(!this.fromAdmin){
          // this.$router.replace({ path: '/productInfoCenter/default', query: { tab: 'Catalog' } });
          // }  
      }
      //   }
      // });
    },
    async Submit() {
      const data = await this.AfterSaveResult();

      const query = {
        FormId: this.companyid,
        Action: 'Before_Submit',
        FormType: 'ProductInfo_Catalogue',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);
      
      //验证tab内是否有未填写的内容
      this.CheckTabRequied();
      return new Promise((resolve, reject) => {
        this.$refs.indexDetail
        .validate(true)
        .then(async (res) => {
          if (res.valid) {
            productService.SaveSubmitCatalogue(data).then(res => {
              if (res.isSuccessful) {
                //不做新增或者修改的判断 成功直接改路由就可以�?
                if (!this.formAdmin && this.ThenCatalogId == 0) {
                  // setTimeout(() => {  
                  this.$router.replace('/productInfoCenter/indexDetail/' + res.data);
                  // }, 300);
                }
              } else {
                this.LogPageFormError({ res: res }, "SaveSubmitCatalogue");
              }

              this.$nextTick(() => {
                this.$store.state.dirty = !res.isSuccessful;
              });
              resolve({ data: res.data, state: res.isSuccessful }); // 用以确定当前不管作为修改亦或者添加id 都作为data 返回
            }).catch(err => {
              console.error(err);
              this.showResultMessagePopup(false, this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message }), true);
              this.LogPageFormError(
                {
                  Error: {
                    ErrorName: err.name,
                    ErrorMessage: err.message,
                    ErrorStack: err.stack
                  }
                },
                "SaveSubmitCatalogue"
              );
              resolve({ data: data.CatalogId, state: false });
            });
          } else {
            this.showResultMessagePopup(false, this.$t("lbl_EMPBE_Please_mandatory_And_exceptions_Tips"), true);
            this.$nextTick(() => {
              this.$store.state.dirty = true;
            });
            resolve({ data: data.CatalogId, state: false }); //用以确定当前不管作为修改亦或者添加id 都作为data 返回
          }
        });
      });
    },

    //     async SaveOrSubmitByStatus(){
    //     const status=this.GetPageState;
    //     if(status==1)
    //     {
    //     this.btnSubmit_Click();
    //     }else{
    //       this.SaveBtnClick = true;
    //         this.btnSave_Click().then(SaveRes => {
    //           if (SaveRes.state) { 
    //              this.showSaveSucess(this.$t('lbl_EMPBE_Save_Success'), this.$t('lbl_EMPBE_ProductInfo_Submit_Body')).then(SaveSucess => {
    //                 if (SaveSucess.isConfirmed) {
    //                  this.Submit().then(res=>{
    //                     if(res&&res.state){
    //                       this.$Alert(0, this.$t("lbl_EMPBE_Submit_Success")); 
    //                       setTimeout(() => {
    //                        var tabtitleObj=document.getElementById('tab_catalog_'+this.catalogId);
    //                         if(tabtitleObj)
    //                         { 
    //                           tabtitleObj.innerText=this.GetCatalogName();
    //                         }
    //                      }, 600);  
    //                     } 
    //                  }); 
    //                 this.SaveBtnClick = false;
    //                 }
    //               }) 
    //           }
    //         });
    //     }
    // },
    deleteCatalog() {
      productService.CatalogueDelete({ companyId: this.companyid, CatalogId: this.ThenCatalogId }).then((res) => {
        this.$submitFormMessage.ShowMesaagePopup({ title: res.isSuccessful ? this.$t('lbl_EMPBE_DeleteSuccess') : this.$t('lbl_EMPBE_DeleteFailed') });

        if (!res.isSuccessful) {
          this.LogPageFormError({ res: res }, "DeleteCatalogue");
        }

        if(res.isSuccessful && !this.fromAdmin){
          setTimeout(() => {
            this.$router.replace({ path: '/productInfoCenter/default', query: { tab: 'Catalog' } });
          }, 300);
        }
      }).catch(err => {
        this.LogPageFormError(
          {
            Error: {
              ErrorName: err.name,
              ErrorMessage: err.message,
              ErrorStack: err.stack
            }
          },
          "DeleteCatalogue"
        );
      });
    },
    backToDefaultPage(){
      // 管理员模式下，通过事件通知父组件隐藏详情页
      if (this.fromAdmin) {
        let status = this.GetPageState;
        if (this.$store.state.dirty) {
          this.showLeavePageAfterSave(
            status == 1 ? this.PageLeaveContent.SubmitTitle : this.PageLeaveContent.SaveTitle,
            status == 1 ? this.PageLeaveContent.SubmitText : this.PageLeaveContent.SaveText,
            status == 1 ? this.PageLeaveContent.SubmitConfirmBtn : this.PageLeaveContent.SaveConfirmBtn
          ).then(async (result) => {
            if (result.isDenied) { 
              this.$emit('hide-detail', 1);
            } else if (result.isConfirmed) {
              if (status == 1) {
                this.Submit().then(SaveRes => {
                  if (SaveRes.state) {
                    this.showResultMessagePopup(true, "", true);
                  }
                }); 
              } else {
                var data = await this.AfterSaveResult();
                productService.SaveCatalogue(data).then(res => {
                  if(res.isSuccessful){
                    setTimeout(() => {
                      this.$emit('hide-detail', 1);
                    }, 300);
                    this.showResultMessagePopup(true, "", false);
                  } else {
                    this.LogPageFormError({ res: res }, "backToDefaultPage_SaveCatalogue");
                    this.showResultMessagePopup(true, this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg.join(",") }), false);
                  }
                }).catch(err => {
                  this.LogPageFormError({
                    Error: {
                      ErrorName: err.name,
                      ErrorMessage: err.message,
                      ErrorStack: err.stack
                    }
                  }, "backToDefaultPage_SaveCatalogue");
                  this.showResultMessagePopup(true, this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message }), false);
                });
              }
            } 
          }); 
        }else{
          this.$emit('hide-detail', 1);
        }      
      } else {
        // 导航回默认路由，显示 productListing 组件，并选中第二个tab（目录列表）
        this.$router.replace({ path: '/productInfoCenter/default', query: { tab: 'Catalog' } });
      }
    },
    //删除和下�?
    DeleteAndDelisted(event) {
      if (event.eventName == "Delete") {
        this.showConfirm(
          this.$t('lbl_EMPBE_ProductInfo_Delete_Title'),
          this.$t('lbl_EMPBE_ProductInfo_Delete_Body'),
          this.$t('lbl_EMPBE_ProductInfo_Delete_Buttom'),
          this.$t('lbl_EMPBE_ProductInfo_Delete_Cancel')
        ).then(async (res) => {
          if (res.isConfirmed) { 
            this.deleteCatalog();
          }
        });
      } else if (event.eventName == "Delist") {
        //下架
        // this.showConfirm("title", "text","confirmButton","cancelButton").then(async (res) => {
        //   if (res.isConfirmed) {
        //删除product
        this.Delist().then(res => {
          if (res) { 
            //var a=this.form.CatalogueModel;
            this.form.CatalogueModel.isLaunch = false;
            setTimeout(() => {
              this.$store.state.dirty = false;
            }, 200); 
            //this.LoadPagetTimer();
            // console.log("下架成功");
            // setTimeout(() => {
            //   this.$router.replace('/productInfoCenter/default');
            //   //this.refreshParent();
            // }, 500);
          }
        })
        //   }
        // });
      }
    },
    //下架
    Delist() {
      return new Promise((resolve, reject) => {
        productService.DelistProductCatalog({ companyId: this.companyid, catalogId: this.ThenCatalogId }).then(res => {
          this.$submitFormMessage.ShowMesaagePopup({ title: res.isSuccessful ? this.$t('lbl_EMPBE_DelistSuccess') : this.$t('lbl_EMPBE_DelistFailed') });

          if (!res.isSuccessful) {
            this.LogPageFormError({ res: res }, "Delist_ProductCatalogue");
          }

          resolve(res.isSuccessful);
        }).catch(err => {
          this.$submitFormMessage.ShowMesaagePopup({ title: this.$t('lbl_EMPBE_DelistFailed') });
          this.LogPageFormError(
            {
              Error: {
                ErrorName: err.name,
                ErrorMessage: err.message,
                ErrorStack: err.stack
              }
            },
            "Delist_ProductCatalogue"
          );
          reject(err);
        })
      });
    },
    //刪除
    Delete() {
      return new Promise((resolve, reject) => {
        //产品 有沒有ad linkage
        productService.CheckProductBeforeDelete({ productid: this.ThenProductId }).then(res => {
          let message = res.isSuccessful ? this.$t("lbl_EMPBE_DeleteSuccess") : this.$t("lbl_EMPBE_DeleteFailed");
          let title = res.isSuccessful ? this.$t("lbl_EMPBE_DeleteSuccess") : this.$t("lbl_EMPBE_DeleteFailed");

          if (!res.isSuccessful) {
            if (res.data == 'LinkedAd') {
              message = this.$t("lbl_EMPBE_ProductDeleteCheck_LinkedAd");
            }

            this.$submitFormMessage.ShowMesaagePopup({ title, message: title === message ? "" : message });
          } else {
            productService.ProductDelete({ companyId: this.companyid, ProductId: this.ThenProductId }).then(deleteRes => {
              this.$submitFormMessage.ShowMesaagePopup({ title: deleteRes.isSuccessful ? this.$t('lbl_EMPBE_DeleteSuccess') : this.$t('lbl_EMPBE_DeleteFailed') });

              if (!deleteRes.isSuccessful) {
                this.LogPageFormError({ res: deleteRes }, "Delete_ProductCatalogue");
              }
            }).catch(err => {
              this.$submitFormMessage.ShowMesaagePopup({ title: this.$t('lbl_EMPBE_DeleteFailed') });
              this.LogPageFormError(
                {
                  Error: {
                    ErrorName: err.name,
                    ErrorMessage: err.message,
                    ErrorStack: err.stack
                  }
                },
                "Delete_ProductCatalogue"
              );
            })
          }
        })
      });
    },
    //  copyToOtherLang(){
    //   this.$swal({
    //     //Show Alert
    //     text: this.$t("lbl_EmpBE_ProCatalog_ConfirmApplyTheCatalog"),
    //     showCancelButton: true,
    //     type: "confirm",
    //     showConfirmButton: true,
    //     confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
    //     cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
    //   }).then(async (res) => {
    //     if (res.isConfirmed) {
    //       // 根据当前选中的tab获取源组�?
    //       let sourceRef = null;
    //       let sourcePdfObj = null;
          
    //       if (this.TabIndex === 0) {
    //         // 英文 -> 复制到简体中文和繁体中文
    //         sourceRef = this.$refs.PdfDataEn;
    //         sourcePdfObj = this.GetPdfObjEn;
    //       } else if (this.TabIndex === 1) {
    //         // 简体中�?-> 复制到英文和繁体中文
    //         sourceRef = this.$refs.PdfDataSc;
    //         sourcePdfObj = this.GetPdfObjSc;
    //       } else if (this.TabIndex === 2) {
    //         // 繁体中文 -> 复制到英文和简体中�?
    //         sourceRef = this.$refs.PdfDataTc;
    //         sourcePdfObj = this.GetPdfObjTc;
    //       }
          
    //       if (!sourceRef || !sourcePdfObj) {
    //         this.$Alert(1, this.$t("lbl_EMPBE_Error"));
    //         return;
    //       }
          
    //       // 获取源组件的文件数据
    //       const sourceFileData = sourcePdfObj.fileData;
    //       const sourceFileName = sourcePdfObj.fileName;
    //       const sourceCatalogName = sourcePdfObj.catalogName;
          
    //       // 如果没有文件数据，提示用�?
    //       if (!sourceFileData && !sourceFileName) {
    //         this.$Alert(1, this.$t("lbl_EMPBE_ProductInfo_Catalog_NoFileToCopy"));
    //         return;
    //       }
          
    //       // 复制到其他两个语言的组�?
    //       let targetRefs = [];
    //       let targetPdfObjs = [];
          
    //       if (this.TabIndex === 0) {
    //         // 从英文复制到简体中文和繁体中文
    //         targetRefs = [this.$refs.PdfDataSc, this.$refs.PdfDataTc];
    //         targetPdfObjs = [this.GetPdfObjSc, this.GetPdfObjTc];
    //       } else if (this.TabIndex === 1) {
    //         // 从简体中文复制到英文和繁体中�?
    //         targetRefs = [this.$refs.PdfDataEn, this.$refs.PdfDataTc];
    //         targetPdfObjs = [this.GetPdfObjEn, this.GetPdfObjTc];
    //       } else if (this.TabIndex === 2) {
    //         // 从繁体中文复制到英文和简体中�?
    //         targetRefs = [this.$refs.PdfDataEn, this.$refs.PdfDataSc];
    //         targetPdfObjs = [this.GetPdfObjEn, this.GetPdfObjSc];
    //       }
          
    //       // 复制文件数据到目标组�?
    //       targetPdfObjs.forEach((targetPdfObj, index) => {
    //         if (targetPdfObj) {
    //           // 复制文件数据（如果是FileList，直接复制引用；如果是File对象，也直接复制�?
    //           if (sourceFileData) {
    //             targetPdfObj.fileData = sourceFileData;
    //           }
    //           // 复制文件�?
    //           if (sourceFileName) {
    //             targetPdfObj.fileName = sourceFileName;
    //           }
              
    //           // 更新子组件的显示状�?
    //           if (targetRefs[index]) {
    //             // 如果有文件名，显示链接；如果有文件数据但没有文件名，隐藏链接
    //             targetRefs[index].IsShowLink = sourceFileName ? true : false;
    //           }
    //         }
    //       });
          
    //       this.$Alert(0, this.$t("lbl_EMPBE_CopySuccess"));
    //     }
    //   });
    // },  
  },
  beforeRouteLeave (to, from, next) {
    const status = this.GetPageState;
    if (this.$store.state.dirty) {
      this.showLeavePageAfterSave(
        status == 1 ? this.PageLeaveContent.SubmitTitle : this.PageLeaveContent.SaveTitle,
        status == 1 ? this.PageLeaveContent.SubmitText : this.PageLeaveContent.SaveText,
        status == 1 ? this.PageLeaveContent.SubmitConfirmBtn : this.PageLeaveContent.SaveConfirmBtn
      ).then(async (result) => {
        if (result.isDenied) { 
            next() // 允许离开
        } else if (result.isConfirmed) {
          //提交操作 
          if (status == 1) {
            this.Submit().then(SaveRes => {
              if (SaveRes.state) {
                this.showResultMessagePopup(true, "", true);
                next(false) // 允许离开 
              } else {
                next(false) //  
              }
            }); 
          } else {
            var data = await this.AfterSaveResult();
            productService.SaveCatalogue(data).then(async res => {
              if (res.isSuccessful) {
                if(!this.fromAdmin&& this.ThenCatalogId==0){ 
                  this.$router.replace('/productInfoCenter/indexDetail/' + res.data);  
                }
                this.showResultMessagePopup(true, "", false);
              } else {
                this.LogPageFormError({ res: res }, "beforeRouteLeave_SaveCatalogue");
              }
            }).catch(err => {
              this.LogPageFormError({
                Error: {
                  ErrorName: err.name,
                  ErrorMessage: err.message,
                  ErrorStack: err.stack
                }
              }, "beforeRouteLeave_SaveCatalogue");
            });

            this.$nextTick(() => {
              next();
            });
          }
        } else {
          next(false) // 
        }
      }); 
    }else{
      next() // 允许离开
    }
  }
};
</script>
<style lang="scss">
@import "./style/default";
</style>
<style lang="scss" scoped>
  
.ActivateColor {
  padding: 8px;
  background: var(--Success-Light, #51BB25);
      color: #fff;
    text-align: center;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -.154px;
}

.DraftColor {
  padding: 8px;
  background: var(--Warning, #FFD02C);
 color: rgb(0, 0, 0);
  text-align: center;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -.154px;
}

.DelistedColor {
  padding: 8px;
  background: #7A7A7A;
  color: #fff;
    text-align: center;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -.154px;
}
</style>
<style scoped>
.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.container-fluid {
  position: relative;
}
.tbbody {
  display:flex;
  justify-content: center;
  position: relative;
}
.form {
  width: 888px;
}
.TabHeader{
width: 888px;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
display: inline-flex;
position: fixed;
 top: 30px;
     position: fixed; 
    z-index: 3;
    background: #F8F8F8; 
}
.TabHeader_body{
 width: 100%; 
  border-radius: 16px;  
  align-items: center; 
  display: inline-flex;
  height: 34px;
  margin: 16px 0;
  padding: 0 16px;
  position: relative;
}
.topMenuRight{
    gap: 24px;
    height: 34px;
    border-radius: 16px;
    justify-content: flex-end;
    align-items: center;
    display: flex;
    position: absolute;
    right: 0;
}
.backToDefaultPage{
  padding: 3.20px; background: rgba(0, 0, 0, 0.03); border-radius: 799.20px; justify-content: flex-start; align-items: center; gap: 8px; 
  display: flex;
  cursor: pointer;
}
form .bCard {
    border: 1px solid var(--Outline-Surface-Border, #f2f3f5) !important;
    background: var(--Surface, #fff) !important;
    border-radius: 24px !important;
    padding: 24px;
    margin-top: 32px;
}
.card .card-body{
      padding: unset;
}  
.lblCatalogList{
  color: rgba(0, 0, 0, 0.40);
   font-size: 18px; 
  /* font-family: Inter;  */
  font-weight: 400; 
  line-height: 23.40px; 
  word-wrap: break-word;
  position: relative;
  cursor: pointer;
}
.productTitle{
      color: rgba(0, 0, 0, 0.8);
    font-size: 18px;
    /* font-family: Inter; */
    font-weight: 700;
    line-height: 23.4px; 
    white-space: nowrap;
    overflow: hidden;
    max-width: inline;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    max-width: 895px;
    text-overflow: ellipsis;
}
/* .lblCatalogList .split{
border-right: 0.125rem solid rgb(0, 0, 0, 0.15);
    height: 18px;
    display: inline-block;
    position: absolute;
    width: 8px;
    top: 3px;  
} */
 .iconRight{
  font-size: 20px;
    color: rgba(0, 0, 0, 0.4);
    width: 20px;
    align-items: center;
    justify-content: center;
    display: flex;
 }
.btnCopyToOtherLang{
  padding:15px 16px;
  padding-bottom: 15px; 
  background: #7366FF; 
  border-radius: 4px; 
  justify-content: center; 
  align-items: center; gap: 8px; display: inline-flex;
  color: white;
  font-size: 14px;
  /* font-family: Inter; */
  font-weight: 700;
  line-height: 21px;
  cursor: pointer;
}

</style>
<style scoped>
.formAdmin .bCard { 
  margin-top: 15px;
}
.TabHeader_admin{
  margin: 8px 0 !important;
}
</style>
